import Grid from "@mui/material/Grid";
import React from "react";

const DashboardContentReportsV3 = ({
  children,
  isFullWidth,
  viewportFill = false,
}) => {
  const contentStyle = viewportFill
    ? {
        flex: 1,
        display: "flex",
        flexDirection: "column",
        minHeight: 0,
        padding: 0,
      }
    : {};

  const containerStyle = viewportFill
    ? {
        flex: 1,
        display: "flex",
        flexDirection: "column",
        minHeight: 0,
        minWidth: 0,
        width: "100%",
        maxWidth: "100%",
      }
    : {};

  const gridStyle = viewportFill
    ? {
        flex: 1,
        display: "flex",
        flexDirection: "column",
        minHeight: 0,
        minWidth: 0,
        width: "100%",
        maxWidth: "100%",
        margin: 0,
      }
    : {};

  return (
    <div style={contentStyle}>
      <div
        className={`${isFullWidth ? "container full-width" : "container"}`}
        style={containerStyle}
      >
        <Grid container spacing={3} style={gridStyle}>
          {children}
        </Grid>
      </div>
    </div>
  );
};

export default DashboardContentReportsV3;
